function validatePassword(value: string | undefined) {
  if (!value) return false;

  return (
    value.length >= 8 &&
    value.length <= 64 &&
    /[A-Z]/.test(value) && // At least one uppercase letter
    /[a-z]/.test(value) && // At least one lowercase letter
    /\d/.test(value) && // At least one number
    /\W/.test(value) // At least one special character
  );
}

export default validatePassword;
